import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import {
    getShopFromOrder,
    getDateFormat,
    displayPriceFormat,
    getPaymentTypeData,
    isOrderRefunded,
    formatPhoneWithPlus,
    getAddressFormatted
} from "../../../utils";
import OrderTotal from "./OrderTotal";
import { getIcon, Divider } from "@dishopsaas/design-system";
import getStyles from "../Order.styles";
import OrderStatusIndicator from "./OrderStatusIndicator";
import renderOrderType from "./orderType";
import OrderCart from "./OrderCart.view";
import LoyaltyBanner from "../../LoyaltyBanner/LoyaltyBanner";

type Props = {
    order: any;
    showFees: boolean;
    deleteOption?: boolean;
    orderType?: string;
    totalPrice?: string;
    isMobile?: boolean;
    isPastOrder?: boolean;
    EmergencyBlock?: any
};

export default function OrderDetailsContent({
    order,
    showFees,
    deleteOption,
    orderType,
    totalPrice,
    isMobile,
    isPastOrder,
    EmergencyBlock
}: Props) {
    const { date, commande, paymentType, totalProductPriceOrder, address } = order;
    const { paymentTypeLabel, icon } = getPaymentTypeData(paymentType);
    const styles = getStyles()
    const shop = useMemo(() => getShopFromOrder(order), [order]);
    const phone = shop?.support?.number
    const isRefunded = useMemo(
        () =>
            isOrderRefunded(order),
        [order]
    );


    return (
        <>
            <Box sx={{ width: "100%" }}>
                <Box sx={styles.topContent}>
                    <Box sx={styles.topBlock}>
                        <Box sx={styles.shop}>
                            <Typography variant="body1" sx={styles.shopName}>{shop?.name}</Typography>
                            <Typography variant="body1">
                                {renderOrderType(orderType)}
                            </Typography>
                        </Box>

                        {isPastOrder ? (<Box sx={styles.total}>
                            <Typography variant="subtitle2">Total TTC</Typography>
                            <Typography variant="subtitle2">
                                {displayPriceFormat(totalPrice)}
                            </Typography>
                        </Box>)
                            : (<>
                                <Box sx={styles.total}>
                                    <Typography variant="body1">{getAddressFormatted(address)}</Typography>

                                </Box>
                                <Box sx={styles.total}>
                                    <Typography variant="body1" onClick={() => window.open(`tel:${phone}`)} sx={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}>
                                        {formatPhoneWithPlus(phone)}
                                    </Typography>
                                </Box>
                            </>
                            )}
                    </Box>

                    <Box sx={styles.bottomBlock}>
                        <Box sx={styles.date}>
                            <Typography variant="subtitle1">Date</Typography>
                            <Typography variant="body2">{getDateFormat(date)}</Typography>
                        </Box>

                        <Box sx={styles.status}>
                            <Typography variant="subtitle1">Statut</Typography>
                            <OrderStatusIndicator order={order} isMobile={isMobile} isPast={isPastOrder} />
                        </Box>

                    </Box>

                </Box>
                {EmergencyBlock && <Divider />}
                {EmergencyBlock}

                <OrderCart
                    commande={commande}
                    deleteOption={deleteOption}
                    styles={styles}
                    title="Panier"
                    isPastOrder={isPastOrder}
                />
                <OrderTotal
                    commande={order.commande}
                    promotion={order.promotion}
                    showFees={showFees}
                    marketingCampaignPromoAmount={order.marketingCampaignPromoAmount}
                    totalPriceOrder={order.totalPriceOrder}
                    managementFee={order.managementFee}
                    totalProductPriceOrder={totalProductPriceOrder}
                    isPast={true}
                />
                <Box sx={styles.paymentBox}>
                    <Typography variant="h5" sx={styles.capitalize}>
                        Paiement
                    </Typography>
                    <LoyaltyBanner commande={commande} />
                    <Box sx={styles.paymentRow}>
                        <Box sx={styles.paymentLabel}>
                            {getIcon(icon, { size: 20 })}
                            <Typography variant="body1">{paymentTypeLabel}</Typography>
                        </Box>
                    </Box>
                    {isPastOrder && isRefunded && (
                        <Typography
                            variant="caption"
                            sx={{ color: "red", textAlign: "center" }}
                        >
                            Votre paiement a été remboursé. Il devrait apparaître sur votre
                            compte bancaire d'ici une semaine.
                        </Typography>
                    )}
                </Box>

            </Box>

        </>
    );
}